const ShippingPolicy = () => {
  return (
    <div className="privacy-container m-4 shadow-4 p-5 rounded">
      <h1 className="privacy-title">Shipping Policy</h1>
      {/* <p className="privacy-date">Effective Date: [18-04-2025]</p> */}
      <p className="privacy-website">Website: https://kidschoice.co.in</p>

      <h2>1. Shipping Methods</h2>
      <p>
        We offer standard and express shipping options. Delivery timeframes vary
        depending on your location.
      </p>

      <h2>2. Processing Time</h2>
      <p>
        Orders are processed within 1–2 business days. During high demand,
        processing may take longer.
      </p>

      <h2>3. Shipping Charges</h2>
      <p>
        Shipping charges are calculated at checkout based on your order value
        and location.
      </p>

      <h2>4. International Shipping</h2>
      <p>
        Currently, we only ship within India. We do not offer international
        shipping at this time.
      </p>

      <h2>5. Delays</h2>
      <p>
        Delays may occur due to holidays, weather, or carrier issues. We are not
        responsible for such delays.
      </p>

      <h2>6. Tracking Your Order</h2>
      <p>
        You will receive an email with tracking details once your order has
        shipped.
      </p>

      <h2>7. Undeliverable Packages</h2>
      <p>
        If a package is returned due to an incorrect address or failed delivery,
        we will contact you for re-shipping.
      </p>

      <h2>8. Contact Us</h2>
      <p>For shipping questions, email: support@kidschoice.co.in</p>
    </div>
  );
};

export default ShippingPolicy;
